import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { axiosClient } from "./apiClient";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
//import { Carousel, Props } from "react-responsive-carousel";
//import 'react-responsive-carousel/lib/styles/carousel.css';
import { Carousel } from 'react-carousel-minimal';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

const CarouselViewer = () => {
  const { id } = useParams();
  const { group_id } = useParams();
  const navigate = useNavigate();
  const [carouselData, setCarouselData] = useState([]);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  
  if(language != "swe" && language != "eng"){
    console.log("Byter språk pga fel...");
    i18n.changeLanguage('swe');
  }

  const reset = () => {
    //setExhibitionItem([]);
    navigate(`/carousel/${id}`);
    window.location.reload(false);
  }

  const onIdle = () => {
    reset();
  }
  const onActive = (event) => {
    
  }
  const idleTimer = useIdleTimer({ onIdle, onActive, timeout: 120000 });

  let isMounted = true;
  let showCases = [];
  const getShowcaseSummary = async () => {
    //console.log("getShowcaseSummary");
    const groupIds = [];
    try {
      //console.log(`kua/api/v1/resources/showcasesummary/${id}`);
      const { data } = await axiosClient.get(`kua/api/v1/resources/showcasesummary/${id}`);
      //console.log(data);
      if(data) {
        //console.log("showcaseSummary RESOLVED!");
        showCases = data;
        data.map((item) => (
          groupIds.push(item.item_group_id)
        ));
        getItemGroupSummary(groupIds);
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  /*useEffect(() => {
    getShowcaseSummary();
  }, [id]);*/

  useEffect(() => {
    getShowcaseSummary();
    return () => { isMounted = false };
  }, [id]);
  
  const getItemGroupSummary = (groupIds) => {
    //console.log("getItemGroupSummary");
    const endpoints = [];
    groupIds.map((item) => (
      endpoints.push(`kua/api/v1/resources/itemgroupsummary/${item}/${language}`)
    ));
    Promise.all(endpoints.map((endpoint) => axiosClient.get(endpoint))).then( res => {
      //console.log(res);
      var children = [];
      res.map((a, index) => {
          children.push(a.data[0]);
      });
      
      let test = [];
      showCases.map((a, index) => {
        test[index] = {
          ...showCases[index],
          ...children[index]
        };
      });
      let cd = [];
      test.map((a, index) => {
        cd.push({"caption": a.item_text, 
                "image": a.item_url, 
                "thumbnail": a.thumbnail_small_url, 
                "original": a.medium_url, 
                "description": <div dangerouslySetInnerHTML={{ __html: a.item_text }} />, 
                "originalHeight": "500px"
              });
      });
      if(isMounted) {
        setCarouselData(cd);
      }
      //console.log(cd);
      //console.log(showCases);
      //console.log(test);
      //console.log("getItemGroupSummary RESOLVED!");
    });
  };

  const captionStyle = {
    fontSize: '2em',
    fontWeight: 'bold',
  }

  const slideNumberStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
  }

  const carouselData_ = [{"caption":"<h2>Kronprinsessan Victoria</h2>\r\n<p>Det svenska kronprinsparet Gustaf och Victoria tillbringade vintern 1890–1891 i Egypten. Tanken var att landets klimat skulle verka välgörande på kronprinsessans klena hälsa. En andra resa följde året därpå, då utan kronprinsen. Victoria var en hängiven amatörfotograf och drygt 3000 bevarade fotografier från resorna visar på hennes skarpa blick för både faraoniska monument och modernt folkliv. En minnesvärd egyptologisk insats var att hon bekostade utgrävningen av ämbetsmannen Harkhufs grav som innehåller en av den egyptiska litteraturens mest kända texter. Victorias egna samling med faraoniska antikviteter lämnades i olika omgångar till Uppsala universitet. I tacksamhet för kronprinsessans välvilja bytte det egyptiska museet (då inrättat i Ekermanska huset, det vill säga Historicum) namn till ”Victoriamuseet för egyptiska fornsaker”. I dag hör föremålen till Gustavianum, Uppsala universitetsmuseum.</p>","image":"https://bruno.ub.uu.se/kua_pictures/ill_22_Victoria_fotograferar.jpg/full/full/0/default.jpg"},{"caption":"<h2>Del av kista</h2>\r\n<p>Under början av det  1:a årtusendet f.Kr. var Egypten, under den tid som är känd som tredje mellanperioden, politiskt splittrat och svagt. Det märks dock inte i konsthantverket som ofta är av hög kvalitet. Mycket karakteristiska för den här tiden är kistorna av trä med polykrom dekoration mot gul bakgrund. Här är ett fragment från en kvinnokista där Osiris och Isis förekommer i två scener. Fastän bara två färger använts för hieroglyferna, har man följt traditionen att använda röd färg för kroppsdelar (ser du tecknen som avbildar ben, arm, mun?). Föremålet är inköpt till dåvarande Victoriamuseet från en ungersk privatsamling 1936.</p>","image":"https://bruno.ub.uu.se/kua_pictures/kistan.jpg/full/full/0/default.jpg"},{"caption":"<h3>Echnatons kartusch</h3>\r\n<p>Bland de föremål som kommit genom Victoria finns ett fragment med en kartusch med farao Echnatons namn, vilken är ihågkommen för att ha infört historiens första monoteistiska religion.</p>","image":"https://bruno.ub.uu.se/kua_pictures/eknaton.jpg/full/full/0/default.jpg"},{"caption":"<h2>Georg Möllers <em>Hieratische Paläographie</em></h2>\r\n<p>Georg Möller var en tysk egyptolog som hade oturen att avlida under ett besök i Uppsala hösten 1921. Ännu i dag är hans hieratiska paleografi (skriftlära) standardlitteratur under utbildningen för alla som läser egyptologi. Hieratiska är den form hieroglyferna antar när de behöver skrivas med pensel på papyrus eller som graffiti. Tecknens bildkaraktär går då i stor utsträckning förlorad. Just det här exemplaret, som är i privat ägo, råkar ha hört till Möller själv och innehåller olika tillägg. Möllers grav finns på Uppsala Gamla Kyrkogård.</p>","image":"https://bruno.ub.uu.se/kua_pictures/moller.jpg/full/full/0/default.jpg"},{"caption":"<h2>Setjairetbenets stele</h2>\r\n<p>Egyptierna hade en stark tro på att det fanns ett liv efter detta. På den avbildade gravstelen ses en kvinna vid namn Setjairetbenet som kan antas ha dött mot mitten av 500-talet f.Kr. Till höger tillber hon den falkhövdade Re-Horakhty, till vänster skaparguden Atum. Dessa gudar utgör tillsammans solens morgon- och kvällsaspekter. Att få färdas med solen över himlavalvet och födas på nytt med solen garanterade den dödas pånyttfödelse. Texten erbjuder en variant av kapitel 15 i <em>De dödas bok</em>, även kallad dödsboken, som är mest bekant för sin förekomst på papyrusrullar.</p>","image":"https://bruno.ub.uu.se/kua_pictures/VM_3035_1.jpg/full/full/0/default.jpg"},{"caption":"<h2>Hieratiskt ostrakon</h2>\r\n<p>Våld var tyvärr inget främmande för det gamla Egypten. Räckte inte de egna fysiska resurserna, kunde fienden elimineras, tänkte man sig, genom att tillgripa magi. I den här texten som skrevs på en kalkstensskärva (med fackterm ett ostrakon) mot slutet av 1000-talet f.Kr. åkallas den krigslike guden Montu som gör att ens motståndare inte blir mer än en insekt som en fågel snappar. Genom att den som reciterar formeln identifierar sig med Horus, den falkhövdade guden, som är den mytologiska sinnebilden för osviklig och rättmätig revansch, är formelns effektivitet säkrad. Texten är skriven med hieratiska som är en kursiv form av hieroglyferna. De röda punkterna hjälper till att strukturera budskapet. Med stor sannolikhet kan texten antas komma från byn Deir el-Medina nära dagens Luxor, där de människor som högg ut och dekorerade de egyptiska faraonernas klippgravar i Konungarnas dal levde. </p>","image":"https://bruno.ub.uu.se/kua_pictures/VM_2364.jpg/full/full/0/default.jpg"},{"caption":"<h2>Karl Piehl</h2>\r\n<p>Sveriges förste egyptolog är Karl Piehl (1853-1904), som 1881 disputerade vid Uppsala universitet. Han erhöll en professur 1893. Med sina donationer av föremål inköpta under resor till Egypten lade han grunden till den egyptiska samling som länge bar namnet ”Victoriamuseet för egyptiska fornsaker” efter kronprinsessan Victoria. Till förmån för samlingen och inköp av undervisningsmaterial såldes biljetter till offentliga föreläsningar à 50 öre styck. Det fanns planer på att uppföra en separat byggnad för ett egyptiskt museum i Observatorieparken i Uppsala men de förverkligades aldrig. Idag finns de egyptiska antikviteterna på Gustavianum, Uppsala universitetsmuseum.</p>","image":"https://bruno.ub.uu.se/kua_pictures/piehl.jpg/full/full/0/default.jpg"},{"caption":"<h2>Avhandlingar i egyptologi</h2>\r\n<p>Inalles arton avhandlingar i egyptologi har hittills blivit godkända vid Uppsala universitet. Under ämnets första hundra år skrevs lika många som under de senaste fyrtio åren. Ämnena är lika varierade som anspråksfulla. Religiösa ämnen har varit prominenta men där ryms också grammatiska arbeten och keramikanalys. Tre av avhandlingarna är skrivna av personer som så småningom beklädde lärostolen i ämnet. Sju är skrivna av kvinnor. Bland Uppsalaegyptologernas övriga arbeten förtjänar Gertie Englunds lärobok till det klassiska mellanegyptiska språket att bli särskilt ihågkommen.</p>","image":"https://bruno.ub.uu.se/kua_pictures/avhandl.jpg/full/full/0/default.jpg"}];
  
  const d = () => {
    return carouselData;
  }

  return (
  
      <ImageGallery
        items={carouselData} autoPlay="true" slideInterval="10000"
      />

  );
};

export default CarouselViewer;

/*
<Carousel width="800px" showArrows={true}>
        {exhibitionCarousel?.map((item, index) => (
          <div key={index}>
            <img src={item.item_url} />
            <p className="legend">{item.item_text}</p>
          </div>
        ))}
      </Carousel>
*/

/*

//  carouselData ? 

    <>
      //  carouselData ? 
      <div>
        <Carousel
          data={carouselData}
          time={2000}
          width="850px"
          height="500px"
          captionStyle={captionStyle}
          radius="10px"
          slideNumber={true}
          slideNumberStyle={slideNumberStyle}
          captionPosition="bottom"
          automatic={true}
          dots={true}
          pauseIconColor="white"
          pauseIconSize="40px"
          slideBackgroundColor="darkgrey"
          slideImageFit="cover"
          thumbnails={true}
          thumbnailWidth="100px"
          style={{
            textAlign: "center",
            maxWidth: "850px",
            maxHeight: "500px",
            margin: "40px auto",
          }} />
      </div> //: "loading..."

*/